// 定期便のお休み・解約 (sections/teiki-otetsuzuki.liquid): optional reason toggles that filter the offer cards,
// and Shopify customer events. Without this file every offer is listed and the cancel link works as a plain link.
// Events never carry personal data and never delay navigation (publish is fire-and-forget, no preventDefault).
(function () {
  'use strict';
  var root = document.querySelector('[data-teiki]');
  if (!root) return;
  var selected = '';

  function publish(name, offer, step) {
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') return;
      var payload = { reason: selected, offer: offer || '' };
      if (step) payload.step = step;
      analytics.publish(name, payload);
    } catch (error) { /* measurement must never break the page */ }
  }

  var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-teiki-reason]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('.teiki-offers--reason [data-teiki-offer-card]'));
  var status = root.querySelector('[data-teiki-status]');
  var chooser = root.querySelector('[data-teiki-reasons]');

  function apply() {
    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-teiki-reason') === selected));
    });
    cards.forEach(function (card) {
      card.hidden = selected !== '' && card.getAttribute('data-reasons').indexOf(',' + selected + ',') === -1;
    });
    root.classList.toggle('teiki--selected', selected !== '');
    root.querySelectorAll('[data-teiki-reason-field]').forEach(function (field) { field.value = selected; });
    if (status) status.textContent = status.getAttribute(selected ? 'data-selected' : 'data-all');
  }

  if (chooser && buttons.length) {
    chooser.hidden = false;
    root.classList.add('teiki--js');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-teiki-reason');
        selected = selected === id ? '' : id;
        apply();
        if (selected) publish('teiki_reason_select');
      });
    });
  }

  root.addEventListener('click', function (event) {
    var target = event.target.closest('[data-teiki-cancel], [data-teiki-offer]');
    if (!target || !root.contains(target)) return;
    if (target.hasAttribute('data-teiki-cancel')) publish('teiki_cancel_proceed');
    else publish('teiki_offer_click', target.getAttribute('data-teiki-offer'), target.tagName === 'SUMMARY' ? 'open' : 'click');
  });
  root.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-teiki-offer-form]');
    if (form) publish('teiki_offer_click', form.getAttribute('data-teiki-offer-form'), 'submit');
  });

  var notice = root.querySelector('.teiki-notice');
  if (notice) notice.focus();
  publish('teiki_flow_view');
}());
